<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 class="card-title">Mail Taslakları</h4>
                  <p class="card-category">Taslağı bir kere oluşturun, birden fazla kişiye tek seferde gönderin.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="createNew()">
                    Yeni Oluştur
                  </button>
                </div>
              </div>

            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column" :class="getColumnClass(column)">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData" :key="item._id">
                  <slot :row="item">
                    <td class="col-3">{{ item.title }}</td>
                    <td class="col-3">{{ item.header }}</td>
                    <td class="col-2">{{ formatDate(item.createdAt) }}</td>
                    <td class="col-1 text-center">{{ item.totalReceivers }}</td>
                    <td class="col-1 text-center">{{ item.pendingCount }}</td>
                    <td class="col-1 text-center">{{ item.sendedCount }}</td>
                    <td class="col-1 text-center">{{ item.errorCount }}</td>
                    <td class="col-1 text-center">{{ item.openedCount }}</td>
                    <td class="col-1 text-center">
                      <button class="btn btn-sm" @click="openDeleteModal(item)">
                        <i class="nc-icon nc-simple-remove"></i>
                      </button>
                    </td>
                    <td class="col-1 text-center">
                      <button class="btn btn-sm" @click="editMailTemplate(item._id)">
                        <i class="nc-icon nc-simple-edit"></i>
                      </button>
                    </td>
                    <td class="col-1 text-center">
                      <button class="btn btn-sm" @click="testModalLaunch(item)">
                        <i class="nc-icon nc-tablet-2"></i>
                      </button>
                    </td>
                    <td class="col-1 text-center"></td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>


          <div class="modal fade show bg-gray" tabindex="-1"
            :style="testTemplateModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true"
            role="dialog">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLiveLabel">Test Maili Gönderme</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="testModalLaunch(null)">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>

                <div class="modal-body">
                  <label><strong>Kod İsmi:</strong><br>{{ testTemplateModal.template ? testTemplateModal.template.title :
                    '' }}</label>
                  <label><strong>Mail Başlığı:</strong><br>{{ testTemplateModal.header ?
                    testTemplateModal.template.header : '' }}</label>


                  <base-input type="text" label="Test Alıcısı" placeholder="Bir mail adresi Giriniz"
                    v-model="testTemplateModal.receiver">
                  </base-input>


                  <div class="form-group">
                    <label for="fromMailId">Hangi Mail Adresinden?</label>
                    <select id="fromMailId" class="form-control" v-model="testTemplateModal.sender">
                      <option v-for="el of fromMails" :value="el._id">{{ el.mail }}</option>
                    </select>
                  </div>


                </div>
                <div class="modal-footer">

                  <button type="button" @click="testModalLaunch(null)" class="btn btn-secondary"
                    data-dismiss="modal">Kapat</button>
                  <button type="button" @click="testTemplateModalSend()" class="btn btn-primary">Gönder</button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade show bg-gray" tabindex="-1"
            :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLiveLabel">Taslağı silmek istediğinize emin misiniz?</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="deleteModal = false">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>

                <div class="modal-body">
                  <label><strong>Mail İsmi:</strong> {{ deleteModal.name }}</label><br>
                  <label><strong>Mail Başlığı:</strong> {{ deleteModal.code }}</label>

                </div>
                <div class="modal-footer">

                  <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                    data-dismiss="modal">Kapat</button>
                  <button type="button" @click="deleteTemplate(deleteModal.template._id)"
                    class="btn btn-primary">Sil!</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

const tableColumns = ['Taslak Ismı', 'Mail Başlığı', 'Oluşturma Tarihi', 'Toplam Alıcı', 'Beklemede', 'Gönderildi', 'Hata', 'Okundu', 'Sil', 'Düzenle', 'Test', '']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      tableData: [],
      fromMails: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      testTemplateModal: {
        isOpened: false,
        template: null,
        receiver: '',
        sender: '6467c70743b12157ad891d00'
      },
      deleteModal: {
        isOpened: false,
        template: null,
        name: '',
        code: ''
      }
    }
  },
  mounted() {
    this.getTemplates();
    this.getFromMails();
  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getTemplates();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getFromMails() {
      CollectionService.getCollection('frommail').then((res) => {
        if (res.success == true) {
          this.fromMails = res.fromMails;
        } else {
          console.log('error');
        }
      })
    },
    getTemplates() {
      let q = {};
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: -1 } }
      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('mailtemplate', query).then((res) => {
        if (res.success == true) {
          this.tableData = res.mailTemplates;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {

          console.log('error');
        }
      })
    },
    openDeleteModal(template) {
      console.log(template);
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.template = template;
      this.deleteModal.name = template.header;
      this.deleteModal.code = template.title;
    },
    deleteTemplate(_id) {
      this.deleteModal.isOpened = false;
      CollectionService.deleteItem('mailtemplate', _id).then((res) => {
        this.getTemplates();
      })
    },
    createNew() {
      this.$router.push(`/admin/mailtemplates/create`);
    },
    testModalLaunch(template) {
      this.testTemplateModal.isOpened = !this.testTemplateModal.isOpened
      this.testTemplateModal.template = template
    },
    testTemplateModalSend() {
      CollectionService.postWidthAuth(`mailtemplate/sendTest`, this.testTemplateModal).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', 'Test Maili Gönderildi.')
        } else {
          console.log('error');
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },

    getColumnClass(column) {
      switch (column) {
        case 'Taslak Ismı':
        case 'Mail Başlığı':
          return 'col-3';
        case 'Oluşturma Tarihi':
          return 'col-2';
        default:
          return 'col-1 text-center';
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    editMailTemplate(_id) {
      this.$router.push(`/admin/mailtemplates/${_id}`);
    }
  }
}
</script>
<style scoped>
.table th,
.table td {
  vertical-align: middle;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
</style>
